"use client";

import { c as _c } from "react/compiler-runtime";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import type { INotificationIdentityMentioned } from "@/types/feed.types";
import NotificationWithDrop from "../subcomponents/NotificationWithDrop";
export default function NotificationIdentityMentioned(t0) {
  const $ = _c(7);
  const {
    notification,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  let t1;
  if ($[0] !== activeDrop || $[1] !== notification.created_at || $[2] !== notification.related_drops[0] || $[3] !== onDropContentClick || $[4] !== onQuote || $[5] !== onReply) {
    t1 = <NotificationWithDrop drop={notification.related_drops[0]} actionText="mentioned you" createdAt={notification.created_at} activeDrop={activeDrop} onReply={onReply} onQuote={onQuote} onDropContentClick={onDropContentClick} />;
    $[0] = activeDrop;
    $[1] = notification.created_at;
    $[2] = notification.related_drops[0];
    $[3] = onDropContentClick;
    $[4] = onQuote;
    $[5] = onReply;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}